import { createSlice, createAction, createEntityAdapter } from "@reduxjs/toolkit";

const uploadModelAdapter = createEntityAdapter({
  selectId: (segment) => segment.targetId,
});

const uploadSlice = createSlice({
  name: "uploadModel",
  initialState: uploadModelAdapter.getInitialState({
    loading: false,
  }),
  reducers: {
    modelIsLoading(state) {
      if (!state.loading) {
        state.loading = true;
      }
    },
    addModelData: (state, action) => {
      if (state.loading) {
        let result = action.payload;
        uploadModelAdapter.addOne(state, result);
      }
    },
  },
});
export const {modelIsLoading, addModelData} = uploadSlice.actions;
export default uploadSlice.reducer;
